import { render } from "./AllPostsUser.vue?vue&type=template&id=3e55cfc6"
import script from "./AllPostsUser.vue?vue&type=script&lang=js"
export * from "./AllPostsUser.vue?vue&type=script&lang=js"

import "./AllPostsUser.vue?vue&type=style&index=0&id=3e55cfc6&lang=scss"
script.render = render

export default script